<template>
    <div>
        <div class="head">
            <div class="view0">
                <div class="border-box">
                    <img src="@/assets/image/zhekou.png"/>
                </div>
                
            </div>
            <div class="view1">
                <span style="font-size:medium;font-weight: 700;margin-top: 2rem;font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;">{{disName}}</span>
                <span style="font-size: 13px;margin-top: 0.5rem;">{{parkName+' - 停车场'}}</span>
            </div>
        </div>

        <div class="main">
            <div class="title">
                <span class="lb1" >—————— </span>
                <label class="lb2">领取优惠券</label>
                <span class="lb1"> ——————</span>
            </div>
            <div style="margin-top: 15px;margin-bottom: 15px;">
                <Plate ref='childPlate'></Plate>
            </div>

            <el-button type='success' style="width: 85%;height: 40px;font-size: 15px;" :disabled="payLoading" @click='claim'>领取优惠</el-button>
        </div>
    </div>
</template>


<script>
import Plate from '../components/Plate.vue'
import { Dialog } from 'vant';
import 'vant/lib/dialog/style';
import {post,get} from '../util/util'

export default{
    data(){
        return{
            authForm:null,

            payLoading:false,

            disName:'',
            parkName:'',
        }
    },
    components:{
        Plate,
        [Dialog.name]: Dialog,
    },
    created(){
        let form= window.sessionStorage.getItem("ca_pay_authForm")
        if(form){
            this.authForm = JSON.parse(form)
        }
    },
    mounted(){
        this.payLoading=true
        get("ca/getcodeinfo?code="+this.authForm.shortParam).then(res=>{
            if(res.head.status==="1"){
                this.parkName= res.body.parkName
                this.disName=res.body.disName

                post('pp/createLience',this.authForm).then(res=>{
                    if(res.head.status==="1"){
                        this.$refs.childPlate.SelectNo(res.body.carNumber)
                    }else{
                        Dialog({ message: res.head.message});
                    }
                })
                this.payLoading=false
            }else
                Dialog({ message: res.head.message })
        })
    },
    methods:{
        claim(){
            if(this.authForm.shortParam){
                const child= this.$refs.childPlate
                let no=child.input1+child.input2+child.input3+child.input4+child.input5+child.input6+child.input7+(child.input8==='新能源'?'':child.input8)
                if(!no||no.length<7){
                    Dialog({ message: '请输入正确的车牌号' })
                    return
                }
                child.UpdateLocalPlate(no)

                post('ca/discount',{
                    plateno:no,
                    code:this.authForm.shortParam
                }).then(res=>{
                    if(res.head.status==="1"){
                        Dialog({message:res.head.message})
                        this.$refs.childPlate.SelectNo('')
                        this.payLoading=true
                    }else
                        Dialog({message:res.head.message})
                })
            }
            else
                Dialog({ message: '请扫码优惠' })


        }
    }
}
</script>


<style scoped>
.head{
    height: 10rem;
    width: 90%;
    background-color: green;
    margin-left: 5%;
    margin-top: 1rem;
    border-radius: 0.5rem;
}
.view0{
    height: 4rem;
    width: 100%;
}
.border-box{
    height: 3rem;
    width: 3rem;
    border: 1px solid #eee;
    border-radius: 50%;
    padding: 5px;
    background-color: white;
    position: absolute;
    left: 50%;
    transform:translate(-50%,50%)
}
.border-box image{
    width: 100%;
    height: 100%;
    border-radius: 50%;
}
.view1{
    height: 6rem;
    width: 100%;
    background-color: #E3F2ED;
    border-radius:0 0 0.4rem 0.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.main{
    margin-top: 2rem;
}
.title{
    width: 90%;
    margin-left: 5%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.lb1{
    color: #ccc;
}
.lb2{
    font-size: 0.9rem;
    font-weight: 600;
    font-family:Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
}


</style>